// extracted by mini-css-extract-plugin
var _1 = "ovVf0DCowDEay2oBZu1x";
var _2 = "MlREZVWoSzS9eCEEK5dA";
var _3 = "vGUcoXtV6Ks5F7tNSFus form-group";
export { _1 as "controls", _2 as "messageEditor", _3 as "splitGroup" }
